import React, {useEffect, useState} from 'react'
import {useManagePostRequest} from "../../../../../../hooks/useManagePostRequest/useManagePostRequest";
import useDidMountEffect from "../../../../../../hooks/useDidMountEffect/useDidMountEffect";
import {
    buscarColaboradorAPI,
    editarFlujoDocumentoAPI,
    GetAllFlujoDocumentoAccionesAPI, GetAllFlujoDocumentoCCsAPI, getAllFlujoDocumentoPasosAPI,
    GetAllFlujoDocumentoResponsablesAPI,
    getConfiguracionPaso4API, getEmpleadosToCreateCondicionAPI, GetFlujoDocumentoAllPlantillasCorreoAPI,
    GetFlujoDocumentoPlantillasCorreoActivosAPI, registrarFlujoDocumentoAPI, validarRegistrarFlujoDocumentoPaso4API,
} from "../../../../../../consumers/backendApisUrls";
import Select from "react-select";
import {
    handleFind,
    handleFindDropdownMultiSelected,
    handleFindDropdownSelected, initialAllOptionPromises,
    isNullOrUndefinded
} from "../../../../../../helper/utils";
import {useGetOptionsSelect} from "../../../../../../hooks/useGetOptionsSelect/useGetOptionsSelect";
import {v4 as uuidv4} from 'uuid';
import {useManageGetRequest} from "../../../../../../hooks/useManageGetRequest/useManageGetRequest";
import {IdsAcciones, IdsDeOptionsValidosParaPaso1, IdsPasos} from "../../../../constantes/constantes";
import InputSearchAsync from "../../../../../../components/modalComponents/InputSearchAsync";
import InputBool from "../../../../../../components/modalComponents/InputBool";

const Paso4 = ({
                   sendCurrentStep,
                   componentStep,
                   formValues,
                   toggleModal,
                   refreshPage,
                   paso4Filas,
                   setPaso4Filas,
                   paso3Filtros,
                   IdFlujoDocumento,
                   disableInputs,
                   botonGuardarRef,
                   isCreate
               }) => {

    const [executeManagePost] = useManagePostRequest();
    const [allDropdowns, setAllDropdowns] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const KEYS_DROPDOWN = ["IdFlujoDocumentoPaso", "IdEtiquetaResponsable", "IdsEtiquetasCC", "IdFlujoDocumentoPasoAccion", "IdCorreoTemplate"];
    const [getOption] = useGetOptionsSelect();
    const [executeManageGet] = useManageGetRequest();
    const [allConfigurationOptions, setAllConfigurationOptions] = useState([]);

    const KEYS = {
        IdsUnidades: "IdsUnidades",
        Incluye: "Incluye",
        IdsCargos: "IdsCargos",
        IdFlujoDocumentoPaso: "IdFlujoDocumentoPaso",
        IdEtiquetaResponsable: "IdEtiquetaResponsable",
        IdsEtiquetasCC: "IdsEtiquetasCC",
        IdAccion: "IdFlujoDocumentoPasoAccion",
        IdCorreoTemplate: "IdCorreoTemplate",
        EmpleadoResponsable: "EmpleadoResponsable",
        EmpleadosCC: "EmpleadosCC",
        ResponsableEsEmpleado: "ResponsableEsEmpleado"
    }

    async function getConfiguracionPaso4() {
        try {
            const api = getConfiguracionPaso4API();
            await executeManageGet(api, (res) => successCallbackGetConfiguracionPaso4API(res), false);
        } catch (error) {
            console.error(error)
        }
    }

    const successCallbackGetConfiguracionPaso4API = (res) => {
        setAllConfigurationOptions(res?.data);
    }

    const getDropdowns = async () => {
        setIsLoading(true);

        let apiGetPlantillasCorreo = isCreate ?
            GetFlujoDocumentoPlantillasCorreoActivosAPI()
            :
            GetFlujoDocumentoAllPlantillasCorreoAPI();

        const dropdownsPromises = () => [
            getOption(getAllFlujoDocumentoPasosAPI()),
            getOption(GetAllFlujoDocumentoResponsablesAPI()),
            getOption(GetAllFlujoDocumentoCCsAPI()),
            getOption(GetAllFlujoDocumentoAccionesAPI()),
            getOption(apiGetPlantillasCorreo),
        ];
        await initialAllOptionPromises(
            dropdownsPromises,
            KEYS_DROPDOWN,
            handleDropdowns
        );
        setIsLoading(false);
    };

    const handleDropdowns = (data) => {
        setAllDropdowns(data);
    };

    useDidMountEffect(() => {
        if (sendCurrentStep?.step === componentStep && sendCurrentStep?.isSent) {

            handleSubmit();

        }
    }, [sendCurrentStep])

    const handleSubmit = async (e) => {
        if (e) e.preventDefault();

        let payload = {"Items": paso4Filas}

        const api = validarRegistrarFlujoDocumentoPaso4API();
        await executeManagePost(api, payload, ({data}) => RegistrarFlujoDocumentoPaso4(data), false, null, true);


    }

    const RegistrarFlujoDocumentoPaso4 = async (responseData) => {

        const payload = {
            "Paso1": {
                ...formValues, DocumentoContent: null
            },
            "Paso2": {
                ...formValues,
            },
            "Paso3": {
                ValidarRegistrarFlujoDocumentoPaso3Filtros: paso3Filtros,
                ...formValues,
                DocumentoContent: null
            },
            "Paso4": {"Items": paso4Filas},
            "IdFlujoDocumento": IdFlujoDocumento
        }

        const api = isNullOrUndefinded(IdFlujoDocumento) ? registrarFlujoDocumentoAPI() : editarFlujoDocumentoAPI();
        if (botonGuardarRef.current) botonGuardarRef.current.disabled = true;
        await executeManagePost(api, payload, ({data}) => RegistrarFlujoDocumentoPaso4Callback(data), true, null, true);
        if (botonGuardarRef.current) botonGuardarRef.current.disabled = false;
    }

    const RegistrarFlujoDocumentoPaso4Callback = async (responseData) => {
        toggleModal();
        refreshPage()
    }

    const handleChangeFilasMiltiSelect = (e, key, index) => {
        if (!isNullOrUndefinded(e)) {
            const newFilas = [...paso4Filas];
            newFilas[index][key] = Array.isArray(e) ? e.map(x => x.value) : [];
            setPaso4Filas([...newFilas]);
        }
    };

    const handleChangeFilas = (e, key, index) => {
        const value = e?.value;
        if (isNullOrUndefinded(value)) return;

        const newFilas = [...paso4Filas];
        if (!newFilas[index]) return; // seguridad

        // actualizar el campo modificado
        newFilas[index] = {...newFilas[index], [key]: value};

        const pasoSeleccionadoEnFilaModificada = newFilas[index]?.IdFlujoDocumentoPaso;

        // Mapeo de acciones -> paso4Filas adicionales
        const accionesExtra = {
            [IdsAcciones.EnvioToAprobar.Id]: [
                {
                    rowId: uuidv4(),
                    IdFlujoDocumentoPaso: IdsPasos.Aprobar.Id,
                },
                {
                    rowId: uuidv4(),
                    IdFlujoDocumentoPaso: IdsPasos.Observar.Id,
                    IdFlujoDocumentoPasoAccion: IdsAcciones.Paso1.Id,
                },
            ],
            [IdsAcciones.SegundoAprobador.Id]: [
                {
                    rowId: uuidv4(),
                    IdFlujoDocumentoPaso: IdsPasos.Aprobar2.Id,
                    IdFlujoDocumentoPasoAccion: IdsAcciones.Completar.Id,
                },
            ],
        };

        let filasActualizadas = [...newFilas];

        // 🔹 Si estamos en la columna "IdAccion"
        if (key === KEYS.IdAccion) {

            // 🔸 Si el paso actual es "Aprobar" y la acción seleccionada es "Completar"
            if (
                pasoSeleccionadoEnFilaModificada === IdsPasos.Aprobar.Id &&
                value === IdsAcciones.Completar.Id
            ) {
                // 👉 Eliminar la fila con IdFlujoDocumentoPaso == 14 (Aprobar2)
                filasActualizadas = filasActualizadas.filter(
                    (f) => f.IdFlujoDocumentoPaso !== IdsPasos.Aprobar2.Id
                );
            }
        }

        // 🔹 Agregar paso4Filas extra según la acción seleccionada
        if (key === KEYS.IdAccion && accionesExtra[value]) {
            const extras = accionesExtra[value];

            if (value === IdsAcciones.SegundoAprobador.Id) {
                // 🔸 Insertar extras como penúltimos
                const insertPos = filasActualizadas.length - 1;
                filasActualizadas = [
                    ...filasActualizadas.slice(0, insertPos),
                    ...extras,
                    ...filasActualizadas.slice(insertPos),
                ];
            } else {
                // 🔹 Por defecto, agregar al final
                filasActualizadas = [...filasActualizadas, ...extras];
            }
        }

        // 🚫 Evitar duplicados por IdFlujoDocumentoPaso
        const pasosUnicos = new Set();
        filasActualizadas = filasActualizadas.filter(fila => {
            if (!fila.IdFlujoDocumentoPaso) return true; // si no tiene ID aún, se permite
            if (pasosUnicos.has(fila.IdFlujoDocumentoPaso)) return false; // ya existe => eliminar
            pasosUnicos.add(fila.IdFlujoDocumentoPaso);
            return true;
        });

        setPaso4Filas(filasActualizadas);
    };

    const handleChangeFilasForEmpleadoAsyncInput = (e, key, index) => {

        const value = e?.target?.value;
        if (isNullOrUndefinded(value)) return;

        const newFilas = [...paso4Filas];
        if (!newFilas[index]) return;

        newFilas[index] = {...newFilas[index], [key]: value};
        setPaso4Filas([...newFilas]);
    };

    const handleChangeCheckbox = (e, key, index) => {
        const value = e?.target?.checked;
        if (isNullOrUndefinded(value)) return;

        const newFilas = [...paso4Filas];
        if (!newFilas[index]) return;

        newFilas[index] = {
            ...newFilas[index],
            [key]: value,
            [KEYS.IdEtiquetaResponsable]: null,
            [KEYS.EmpleadoResponsable]: null
        };
        setPaso4Filas([...newFilas]);
    };

    const removeValuesFromRow = (row, i) => {
        setPaso4Filas(prevFilas => {
            // 🔹 Mapeamos primero aplicando la lógica actual a la fila seleccionada
            let nuevasFilas = prevFilas.map(item =>
                item.rowId === row.rowId
                    ? {
                        rowId: item.rowId,
                        IdFlujoDocumentoPaso: item.IdFlujoDocumentoPaso,
                        IdCorreoTemplate: item.IdCorreoTemplate,
                    }
                    : {...item}
            );

            // 🔹 Si es la primera fila, eliminamos las demás
            if (i === 0) {
                nuevasFilas = [nuevasFilas[0]];
            }

            return nuevasFilas;
        });
    }

    const init = async () => {
        getConfiguracionPaso4();
        getDropdowns();
    };

    useEffect(() => {
        init();
    }, []);

    const handleFindInConfiguration = (idFlujoDocumentoPaso, key) => {
        let configuration = allConfigurationOptions.find(o => o.IdFlujoDocumentoPaso === idFlujoDocumentoPaso)
        let dropdowns = configuration?.DropDowns;
        return dropdowns?.find(o => o.key == key)?.value;
    };

    return (
        <div>
            <table className="table table-hover table-bordered">
                <thead className="listar-thead">
                <tr>
                    <th className="table-header-bold col-md-2">Paso</th>
                    <th className="table-header-bold col-md-2">Responsable</th>
                    <th className="table-header-bold col-md-2">Plantilla Email</th>
                    <th className="table-header-bold col-md-2">CC</th>
                    <th className="table-header-bold col-md-2">Acción</th>
                </tr>
                </thead>

                <tbody className="listar-tbody">
                {paso4Filas &&
                    paso4Filas.map((row, i) => {
                        // --- 🔹 Acción (columna que nos interesa)
                        const accionOptions = handleFindInConfiguration(row.IdFlujoDocumentoPaso, KEYS.IdAccion) ?? [];
                        const selectedAccion = handleFindDropdownSelected(allDropdowns, row, KEYS.IdAccion) ?? null;
                        const soloUnaOpcion = accionOptions.length === 1;

                        // Si hay solo una opción y aún no está seleccionada, la seleccionamos automáticamente
                        if (soloUnaOpcion && (!selectedAccion || selectedAccion.value !== accionOptions[0].value)) {
                            setTimeout(() => {
                                handleChangeFilas({value: accionOptions[0].value}, KEYS.IdAccion, i);
                            }, 0);

                        }

                        return (
                            <tr key={`${row.rowId}`}>
                                {/* PASO */}
                                <td>
                                    <Select
                                        key={`${row.rowId}-pasoId`}
                                        placeholder="Seleccionar"
                                        value={handleFindDropdownSelected(allDropdowns, row, KEYS.IdFlujoDocumentoPaso)}
                                        options={
                                            handleFind(allDropdowns, KEYS.IdFlujoDocumentoPaso)?.filter((o) =>
                                                i === 0
                                                    ? IdsDeOptionsValidosParaPaso1.includes(o.value)
                                                    : !IdsDeOptionsValidosParaPaso1.includes(o.value)
                                            ) ?? []
                                        }
                                        onChange={(e) => {
                                            handleChangeFilas(e, KEYS.IdFlujoDocumentoPaso, i);
                                            removeValuesFromRow(row, i);
                                        }}
                                        isMulti={false}
                                        isClearable={false}
                                        isDisabled={i !== 0 || disableInputs}
                                    />
                                </td>

                                {/* RESPONSABLE */}
                                <td>
                                    <InputBool
                                        key={`responsableCheckbox-${row.rowId}-${i}`}
                                        textInput={(row[KEYS.ResponsableEsEmpleado] ?? false) === true ? "empleado" : "etiqueta"}
                                        value={row[KEYS.ResponsableEsEmpleado] ?? false}
                                        onChange={(e) => handleChangeCheckbox(e, KEYS.ResponsableEsEmpleado, i)}
                                        name={`admin-input-bool-select-${row.rowId}`}
                                        colLabel={0}
                                        colInput={5}
                                        hasValidationMessage={false}
                                        isDisabled={disableInputs}
                                    />

                                    {(row[KEYS.ResponsableEsEmpleado] ?? false) === false &&
                                        <Select
                                            key={`${row.rowId}-responsable`}
                                            placeholder="Seleccionar"
                                            valueText={handleFindDropdownSelected(allDropdowns, row, KEYS.IdEtiquetaResponsable)?.value ?? null}
                                            value={handleFindDropdownSelected(allDropdowns, row, KEYS.IdEtiquetaResponsable) ?? null}
                                            options={handleFindInConfiguration(row.IdFlujoDocumentoPaso, KEYS.IdEtiquetaResponsable)}
                                            onChange={(e) => handleChangeFilas(e, KEYS.IdEtiquetaResponsable, i)}
                                            isMulti={false}
                                            isClearable={false}
                                            isDisabled={disableInputs || isLoading}
                                        />}

                                    {row[KEYS.ResponsableEsEmpleado] === true &&
                                        <InputSearchAsync typeGet
                                                          api={buscarColaboradorAPI}
                                                          valueText={row[KEYS.EmpleadoResponsable]?.label}
                                                          onChange={(e) => handleChangeFilasForEmpleadoAsyncInput(e, KEYS.EmpleadoResponsable, i)}
                                                          direction="column"
                                                          isDisabled={disableInputs}/>
                                    }

                                </td>

                                {/* PLANTILLA EMAIL */}
                                <td>
                                    <Select
                                        placeholder="Seleccionar"
                                        value={handleFindDropdownSelected(allDropdowns, row, KEYS.IdCorreoTemplate) ?? null}
                                        options={handleFind(allDropdowns, KEYS.IdCorreoTemplate)}
                                        onChange={(e) => handleChangeFilas(e, KEYS.IdCorreoTemplate, i)}
                                        isMulti={false}
                                        isClearable={false}
                                        isDisabled={disableInputs || isLoading}
                                    />
                                </td>

                                {/* CC */}
                                <td>
                                    <Select
                                        key={`${row.rowId}-ccs`}
                                        placeholder="Seleccionar"
                                        value={handleFindDropdownMultiSelected(allDropdowns, row, KEYS.IdsEtiquetasCC)}
                                        options={handleFindInConfiguration(row.IdFlujoDocumentoPaso, KEYS.IdsEtiquetasCC)}
                                        onChange={(e) => handleChangeFilasMiltiSelect(e, KEYS.IdsEtiquetasCC, i)}
                                        isMulti
                                        isClearable={false}
                                        isDisabled={disableInputs || isLoading}
                                    />
                                    <InputSearchAsync typeGet
                                                      api={buscarColaboradorAPI}
                                                      value={row[KEYS.EmpleadosCC]}
                                                      onChange={(e) => handleChangeFilasForEmpleadoAsyncInput(e, KEYS.EmpleadosCC, i)}
                                                      direction="column" isMulti={true}
                                                      isDisabled={disableInputs}/>

                                </td>

                                {/* ACCIÓN (con la lógica nueva) */}
                                <td>
                                    <Select
                                        key={`${row.rowId}-acciones`}
                                        placeholder="Seleccionar"
                                        value={selectedAccion}
                                        options={accionOptions}
                                        onChange={(e) => handleChangeFilas(e, KEYS.IdAccion, i)}
                                        isMulti={false}
                                        isClearable={false}
                                        isDisabled={soloUnaOpcion || disableInputs || isLoading} // 🔸 se desactiva si solo hay una opción
                                    />
                                </td>


                            </tr>
                        );
                    })}
                </tbody>
            </table>

        </div>
    )
}

export default Paso4;